<template>
    <div class="replies">
        <v-layout align-center class="">
<!--            <v-radio-group row v-model="replay.type" class="ml-4">-->
<!--                <v-radio-->
<!--                        label="Text"-->
<!--                        value="text"-->
<!--                ></v-radio>-->
<!--                <v-radio-->
<!--                        label="Blocks"-->
<!--                        value="blocks"-->
<!--                ></v-radio>-->
<!--            </v-radio-group>-->
            <h4 class="heading  font-weight-regular mb-3 user-intent">Bot  Replies With :</h4>
            <v-btn-toggle v-model="replay.type">
                <v-btn value="text" height="30" style = "border-radius: 8px;">
                    Text
                </v-btn>
                <v-btn value="blocks"   height="30" style = "border-radius: 8px;">
                    Blocks
                </v-btn>
            </v-btn-toggle>
        </v-layout>
        <v-autocomplete
                v-if="replay.type === 'blocks'"
                v-model="replay.blocks"
                :items="blocks"
                item-text="name"
                item-value="id"
                chips
                return-object
                outline
                solo
                :multiple = "!singleBlock"
        >
            <template v-slot:selection="data">
                <v-chip
                        :selected="data.selected"
                        close
                        @input="removeBlock(data.item)"
                >
                    <strong>{{ data.item.name }}</strong>&nbsp;
                    <a v-if="allowNewTabs" :href="`/build?block=${data.item.id}`" target="_blank" class="ml-1">
                        <v-icon color="primary" size="15">open_in_new</v-icon>
                    </a>
                </v-chip>
            </template>
        </v-autocomplete>
        <v-textarea
            v-model="replay.text"
            v-if="replay.type === 'text' && !autocompleteVariables"
            outline
        />

        <v-textarea-autocomplete
            v-model="replay.text"
            v-if="replay.type === 'text' && autocompleteVariables"
            type="textarea"
            outline
        />

    </div>

</template>

<script>
    import common from "../../utils/common"
    import VTextareaAutocomplete from "../common/v-textarea-autocomplete"
    import _ from 'lodash'
    export default {
        name: "replays",
        props: {
            replay: {
                type: Object,
                default: ()=>{
                    return {}
                }
            },
            blocks: {
                type: Array,
                default: ()=> {
                    return []
                }
            },
            singleBlock: {
                type: Boolean,
                default: false
            },
            autocompleteVariables: {
                type: Boolean,
                default: false
            },
            allowNewTabs: {
                type: Boolean,
                default: false
            }
        },
        data(){
            return {
            }
        },
        mounted() {
            if(this.autocompleteVariables) {
                this.getVariables()
            }
        },
        methods: {
            removeBlock(block){
                let index = this.replay.blocks.indexOf(block.id)
                this.replay.blocks.splice(index,1)
            },
            getVariables() {
                this.$http_bot.get('/blocks/variables/available')
                .then(response=>{
                  const variables = []
                  for (let i = 0; i<response.data.length; i++) {
                    if (response.data[i].variable !== '') {
                      variables.push(response.data[i])
                    }
                  }
                  variables.push({ variable: 'channel'})
                  this.$store.dispatch('setVariables', variables)
                })
                .catch(error=>{
                  if (error.response.status === 401) {
                    common.logOut()
                  }
                })
             },
        }
    }
</script>

<style>
    .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
        margin-bottom: 0;
        margin-top: -10px;
    }
</style>